import { Injectable } from '@angular/core';

import { MemoryCacheRepository } from './memory-cache.repository';
import { ProfessionalPositionInterface } from '../data';

@Injectable()
export class ProfessionalPositionCacheRepository extends MemoryCacheRepository<ProfessionalPositionInterface[]> {}
